import { SendFeedbackPage } from './../../pages/send-feedback/send-feedback';
import { AccountPage } from "./../../pages/account/account";
import { ViewController, NavController, Events } from "ionic-angular";
import { Component } from "@angular/core";
import { AboutPage } from "../../pages/about/about";

/**
 * Generated class for the PopOverOptionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "pop-over-option",
  templateUrl: "pop-over-option.html"
})
export class PopOverOptionComponent {
  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public events: Events
  ) {
   // console.log("Hello PopOverOptionComponent Component");
  }

  close() {
    this.viewCtrl.dismiss();
  }

  about() {
    this.navCtrl.push(AboutPage, {});
    this.viewCtrl.dismiss();
  }

  accountinfo() {
    this.navCtrl.push(AccountPage, {});
    this.viewCtrl.dismiss();
  }

  feedback() {
    this.navCtrl.push(SendFeedbackPage, {});
    this.viewCtrl.dismiss();
  }

  logout() {
  //  console.log("logout");
    this.viewCtrl.dismiss("logout");
   // this.events.publish("user:logout");
  }
}



// WEBPACK FOOTER //
// ./src/components/pop-over-option/pop-over-option.ts